import React from "react";

type CustomLegendProps = {
  data: any[];
  noDataColor?: string;
};

const CustomLegend: React.FC<CustomLegendProps> = ({
  data,
  noDataColor = "#E0E0E0",
}) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);
  const hasData = total > 0;

  const legendItems = hasData
    ? data
    : [{ label: "No Data", value: 100, color: noDataColor }];

  return (
    <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 px-2 pt-3">
      {legendItems.map((item) => (
        <div key={item.label} className="flex items-center gap-1.5">
          <span
            className="block w-2.5 h-2.5 rounded-full"
            style={{ backgroundColor: item.color }}
          ></span>
          <span className="text-xs text-v2-primary">{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default CustomLegend;
